<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">账单ID</div>
        <el-input v-model="detail.lid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">申请人</div>
        <el-select class="filter__input" size="mini" v-model="detail.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">任务</div>
        <el-select placeholder="请选择任务" v-model="detail.etid" filterable @change="handleEtidChange">
          <el-option v-for="item in taskLists" :key="item.etid" :label="item.title" class="dataForm__input"  :value="item.etid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">口令</div>
        <el-select placeholder="请选择口令" v-model="detail.awid" filterable @change="handleAwidChange">
          <el-option v-for="item in watchwordLists" :key="item.awid" :label="item.title" class="dataForm__input"  :value="item.awid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">项目</div>
        <el-select placeholder="请选择项目" v-model="detail.adid" filterable>
          <el-option v-for="item in adLists" :key="item.adid" :label="item.project" class="dataForm__input"  :value="item.adid"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">项目名称</div>
        <el-input v-model="detail.title" placeholder="" size="mini" class="dataForm__input" :disabled="detail.adid !== ''"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">月份</div>
        <el-select v-model="detail.month" multiple filterable allow-create default-first-option size="medium" placeholder="请选择月份">
          <el-option v-for="item in monthLists" :key="item.name" :label="item.month" :value="item.name"> </el-option>
        </el-select>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">账单类型</div>
        <el-tabs v-model="detail.bill_type" type="card">
          <el-tab-pane label="请款" name="0">
            <div class="dataForm__item mt-20">
              <div class="dataForm__name">支付方式:</div>
              <el-radio-group v-model="pay_type" @input="changePayType">
                <div class="dib mr-20">
                  <el-radio :label="0">银行卡</el-radio>
                  <el-radio :label="1">支付宝</el-radio>
                  <el-radio :label="2">微信</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款依据</div>
              <el-input type="textarea" v-model="detail.verify" rows=4 placeholder="填请款金额来源链接，或者上传付款截图" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.verify" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款账号</div>
              <el-input type="textarea" v-model="detail.account" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>

              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.account" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16" v-if="detail.lid">
              <div class="dataForm__name">打款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="收款" name="1">
           <div class="dataForm__item mt-16">
              <div class="dataForm__name">收支账户</div>
              <el-select placeholder="请选择" v-model="detail.pay_mode">
                <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
              </el-select>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="上家回款" name="2">
           <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款账户</div>
              <el-select placeholder="请选择" v-model="detail.pay_mode">
                <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
              </el-select>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="口令回款" name="3">
           <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款账户</div>
              <el-select placeholder="请选择" v-model="detail.pay_mode">
                <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
              </el-select>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="充值兑换" name="4">
            <div class="dataForm__item mt-20">
              <div class="dataForm__name">支付方式:</div>
              <el-radio-group v-model="pay_type" @input="changePayType">
                <div class="dib mr-20">
                  <el-radio :label="0">银行卡</el-radio>
                  <el-radio :label="1">支付宝</el-radio>
                  <el-radio :label="2">微信</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款账号</div>
              <el-input type="textarea" v-model="detail.account" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>

              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.account" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16" v-if="detail.lid">
              <div class="dataForm__name">打款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="其他" name="5">
            <div class="dataForm__item mt-20">
              <div class="dataForm__name">支付方式:</div>
              <el-radio-group v-model="pay_type" @input="changePayType">
                <div class="dib mr-20">
                  <el-radio :label="0">银行卡</el-radio>
                  <el-radio :label="1">支付宝</el-radio>
                  <el-radio :label="2">微信</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款依据</div>
              <el-input type="textarea" v-model="detail.verify" rows=4 placeholder="填请款金额来源链接，或者上传付款截图" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.verify" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款账号</div>
              <el-input type="textarea" v-model="detail.account" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>

              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.account" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16" v-if="detail.lid">
              <div class="dataForm__name">打款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="任务回款" name="6">
           <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款账户</div>
              <el-select placeholder="请选择" v-model="detail.pay_mode">
                <el-option v-for="item in payModeList" :key="item.value" :label="item.name" class="dataForm__input"  :value="item.value"> </el-option>
              </el-select>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">回款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="快递费" name="7">
            <div class="dataForm__item mt-20">
              <div class="dataForm__name">支付方式:</div>
              <el-radio-group v-model="pay_type" @input="changePayType">
                <div class="dib mr-20">
                  <el-radio :label="0">银行卡</el-radio>
                  <el-radio :label="1">支付宝</el-radio>
                  <el-radio :label="2">微信</el-radio>
                </div>
              </el-radio-group>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款依据</div>
              <el-input type="textarea" v-model="detail.verify" rows=4 placeholder="填请款金额来源链接，或者上传付款截图" size="mini" class="dataForm__input"></el-input>
              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.verify" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">收款账号</div>
              <el-input type="textarea" v-model="detail.account" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>

              <div class="headimg-container relative ml-20" style="width:250px">
                <uploadHeadImage :url.sync="detail.account" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
            <div class="dataForm__item mt-16">
              <div class="dataForm__name">请款金额</div>
              <el-input v-model="detail.amount" placeholder="" size="mini" class="dataForm__input"></el-input>
            </div>
            <div class="dataForm__item mt-16" v-if="detail.lid">
              <div class="dataForm__name">打款截图</div>
              <div class="headimg-container relative" style="width:250px">
                <uploadHeadImage :url.sync="detail.bill_img" :filename="filename" :itype="5"></uploadHeadImage>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="0">未打款</el-radio>
            <el-radio :label="1">已完成</el-radio>
            <el-radio :label="2">取消</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">备注</div>
        <el-input type="textarea" v-model="detail.remark" rows=4 placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">日期</div>
        <el-date-picker v-model="detail.date" type="date" placeholder="选择日期"> </el-date-picker>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="ledgerEdit">保存</button>
      </div>
    </div>
  </article>
</template>

<script>
import util from '../../../script/util'
import {ledgerDetail, ledgerEdit, adConciseLists, operLists, adWatchwordLists, taskLists} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'ledgerEdit',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      opid: '',
      detail: {
        lid: 0,
        opid: 1,
        awid: '',
        etid: '',
        adid: '',
        title: '',
        month: [],
        bill_type: '1',
        verify: '',
        account: '',
        amount: '',
        bill_img: '',
        remark: '',
        pay_mode: 0,
        date: new Date(),
        status: 1
      },
      dialog: false,
      pay_type: 0,
      dateTime: '',
      monthLists: [],
      taskLists: [],
      adLists: [],
      operLists: [],
      watchwordLists: [],
      filename: 'finance',
      payModeList: [
        {
          name: '未打款',
          value: 0
        },
        {
          name: '云山支付宝',
          value: 1
        },
        {
          name: '诗雄支付宝',
          value: 2
        },
        {
          name: '小小贝微信',
          value: 3
        },
        {
          name: '极推公户',
          value: 4
        },
        {
          name: '云山招商银行卡',
          value: 5
        },
        {
          name: '诗雄招商银行卡',
          value: 6
        },
        {
          name: '虚拟账号',
          value: 7
        },
        {
          name: '沙市蚂蚁',
          value: 8
        },
        {
          name: '廖清',
          value: 9
        },
        {
          name: '天河蚂蚁',
          value: 10
        }
      ],
      statusList: [
        {
          name: '未打款',
          value: 0
        },
        {
          name: '已完成',
          value: 1
        },
        {
          name: '取消',
          value: 2
        }

      ]
    }
  },
  methods: {
    handleAdidChange () {
      this.adLists.forEach((item) => {
        if (item.adid === this.detail.adid) {
          this.detail.title = item.project
        }
      })
    },
    handleAwidChange () {
      this.watchwordLists.forEach((item) => {
        if (item.awid === this.detail.awid) {
          this.detail.bill_type = '3'
          this.handleBillTypeChange()
          this.detail.adid = item.adid
          this.handleAdidChange()
        }
      })
    },
    handleEtidChange () {
      console.log('etidchange')
      this.taskLists.forEach((item) => {
        console.log('etidchange1', item.etid, this.detail.etid)
        if (item.etid === this.detail.etid) {
          console.log('etidchange2')
          this.detail.bill_type = '6'
          this.handleBillTypeChange()
          this.detail.awid = item.awid
          this.detail.adid = item.adid
          this.handleAdidChange()
        }
      })
    },
    handleBillTypeChange () {
      if (this.detail.lid === 0) {
        if (['0', '4', '5', '7'].includes(this.detail.bill_type)) {
          this.detail.status = 0
        }
        if (['1', '2', '3', '6'].includes(this.detail.bill_type)) {
          this.detail.status = 1
        }

        if (this.detail.bill_type === '4') {
          this.detail.awid = ''
          this.detail.adid = ''
          this.detail.etid = ''
          this.pay_type = 1
          this.detail.title = '充值后台'
          this.detail.account = 'http://img.jituia.com/leaflet/finance/202409/d390797f9d19ccf17d9e15aa69a7f0ec.png'
          this.detail.month = [this.monthLists[0].month]
        } else {
          // this.detail.title = ''
          this.detail.account = ''
          this.detail.month = []
        }

        if (['0', '5', '7'].includes(this.detail.bill_type)) {
          this.changePayType()
        }
      }
    },
    changePayType () {
      let payType = parseInt(this.pay_type)

      this.operLists.forEach((item) => {
        if (parseInt(this.detail.opid) === item.opid) {
          if (payType === 0) {
            this.detail.account = item.bank
          } else if (payType === 1) {
            this.detail.account = item.alipay
          } else if (payType === 2) {
            this.detail.account = item.wechat
          }
        }
      })
    },
    getMonthList () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1

      for (let i = 0; i < 24; i++) {
        let monthStr = (month > 9) ? month.toString() : ('0' + month)
        let yearMonth = year.toString() + '-' + monthStr
        this.monthLists.push({'name': yearMonth, 'month': yearMonth})
        if (month === 1) {
          year = year - 1
          month = 12
        } else {
          month = month - 1
        }
      }
    },
    getOperLists () {
      let params = {
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid,
              alipay: item.alipay,
              wechat: item.wechat,
              bank: item.bank
            }
          })
        }
      })
    },
    getAdWatchwordLists () {
      let params = {
        l: 500,
        p: 1
      }
      adWatchwordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.watchwordLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.awid + ')',
              adid: item.adid,
              awid: item.awid
            }
          })
        }
      })
    },
    getTaskLists () {
      let params = {
        market: 3,
        l: 1000,
        p: 1
      }
      taskLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.taskLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.etid + ')',
              etid: item.etid,
              adid: item.adid,
              awid: item.awid
            }
          })
        }
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adConciseLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title,
              adid: item.adid,
              project: item.title + '(' + item.adid + ')'
            }
          })
        }
      })
    },
    ledgerDetail () {
      let params = {
        lid: this.detail.lid
      }
      this.loading = true
      ledgerDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          for (let key in this.detail) {
            this.detail[key] = data.d[key]
          }

          this.detail.date = new Date(this.detail.date * 1000)
          this.detail.month = this.detail.month.split(',')
          // this.detail.title = this.detail.title.split(',')
          this.detail.bill_type = this.detail.bill_type.toString()
        }
        this.loading = false
      })
    },
    ledgerEdit () {
      let params = util.cloneObj(this.detail)
      params['date'] = parseInt(this.detail.date.getTime() / 1000)
      params['month'] = params['month'].join(',')
      // params['title'] = params['title'].join(',')

      if (params['adid'] === '') {
        params['adid'] = 0
      }

      if (params['awid'] === '') {
        params['awid'] = 0
      }

      if (params['etid'] === '') {
        params['etid'] = 0
      }

      let content = ''

      if (params['title'] === '') {
        content = '没有选择项目'
      }

      if (params['month'] === '') {
        content = '没有选择月份'
      }

      if (params['amount'] === '') {
        content = '请填写金额'
      }

      if (params['bill_type'] === '1' && params['pay_mode'] === 0) {
        content = '请选择收款账号'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      ledgerEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/ledgerList')
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))

    this.detail.lid = parseInt(this.$route.query.lid || 0)
    if (this.detail.lid) {
      this.ledgerDetail()
    } else {
      this.detail.opid = this.opid
    }

    this.getMonthList()
    this.getOperLists()
    this.getAdWatchwordLists()
    this.getTaskLists()
    this.getAdLists()
  },
  watch: {
    'detail.adid': 'handleAdidChange',
    'detail.opid': 'changePayType',
    'detail.bill_type': 'handleBillTypeChange'
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/finance/ledgerEdit.vue